<script lang="ts" setup>
import FilterTable from "@/components/Common/Table/FilterTable.vue";
import { onMounted, ref, watch } from "vue";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import Swal from "sweetalert2";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useItemStore } from "@/stores/management/item";
import ItemFilter from "./ItemFilter.vue";
import { useField, useForm } from "vee-validate";
import ExcelUploader from "@/components/Common/ExcelUploader.vue";
import CustomSizeLoading from "@/components/Common/CustomSizeLoading.vue";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import axios from "axios";
import { hasAccess } from "@/utils/helper";

const linkAdd = {
  text: "Add Goods/Item",
  url: "/management/item/create",
};

const headers: Header[] = [
  { text: "MSG CODE", value: "msg_code", width: 150 },
  { text: "IMPA CODE", value: "impa_code" },
  { text: "GROUP", value: "category_name" },
  { text: "GROUP CATEGORY", value: "group_category_name" },
  { text: "ITEM", value: "name" },
  { text: "SIZE", value: "size" },
  { text: "IMAGE", value: "image", width: 100 },
  { text: "ACTIONS", value: "action" },
];

const itemStore = useItemStore();
const page = ref<number>(1);
const limit = ref<number>(10);
const totalItems = ref<number>(0);
const listItems = ref<any>([]);
const isLoading = ref(false);
const modalShow = ref<any>(false);
let modalInstance: any;
const previewUrl = ref("");

watch(modalShow, (newVal) => {
  if (modalInstance) {
    if (newVal) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }
});

const emptyStateModal = () => {
  modalShow.value = false;
  file_excel.value = null;
};

const { value: file_excel } = useField<any>("file_excel");

const loadDataItems = async (query = "") => {
  isLoading.value = true;
  const { success, message } = await itemStore.dispatchGetItems(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listItems.value = await itemStore.items.items;
    page.value = await itemStore.items.page;
    limit.value = await itemStore.items.pageSize;
    totalItems.value = await itemStore.items.total;
  }
  isLoading.value = false;
};

const handleServerOptionsUpdate = (options: {
  page: number;
  rowsPerPage: number;
}) => {
  page.value = options.page;
  limit.value = options.rowsPerPage;
  loadDataItems();
};

const handleEdit = (item: any) => {
  router.push("/management/item/" + item);
};

const handleVarian = (item: any) => {
  router.push("/management/varian/create/" + item);
};

const handleDelete = async (item: any) => {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      cancelButton: "btn btn-danger",
      confirmButton: "btn btn-success",
    },
    buttonsStyling: false,
  });
  swalWithBootstrapButtons
    .fire({
      title: `Are you sure want to delete data ${item.name} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
    })
    .then(async (result) => {
      if (result.isConfirmed) {
        const { success, message } = await itemStore.dispatchDelete(item.id);
        if (success) {
          swalWithBootstrapButtons.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
          loadDataItems();
        } else {
          toast.error(message);
        }
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        swalWithBootstrapButtons.fire({
          title: "Cancelled",
          text: "Your action has been aborted",
          icon: "error",
        });
      }
    });
};

const validationSchema = toTypedSchema(
  zod.object({
    // file_excel: zod.instanceof(File)
    //             .refine(
    //               (file) =>
    //                 [
    //                   "application/vnd.ms-excel",
    //                   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //                 ].includes(file.type),
    //               { message: "Invalid document file type" }
    //             ),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const submitFileImport = handleSubmit(async (values) => {
  isLoading.value = true;
  const formData = new FormData();
  formData.append("file_excel", file_excel.value);

  const responseApi = await itemStore.dispatchImport(formData);
  const { success, message } = responseApi;
  if (success == true) {
    isLoading.value = false;
    modalShow.value = false;
    toast.success(
      "Data Successfully Uploaded"
    );
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const downloadFormatImport = async () => {
  axios({
        url: `${process.env.VUE_APP_API_BASE_URL}api/goods/download-import-format`, // Replace with your API endpoint
        method: 'GET',
        responseType: 'blob', // Important: Set responseType to 'blob' to receive binary data
      })
          .then(response => {
            isLoading.value = false;
            modalShow.value = false;
            toast.success(
              "Import Format Successfully Downloaded"
            );

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `goods-import-format.xlsx`); // Set desired filename here
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(err => {
            isLoading.value = false;
            toast.error(err.message);
            console.error('Error downloading Excel file:', err);
          });
};

onMounted(() => {
  setTimeout(() => {
    const modalEl = document.getElementById("modalImport");
    if (modalEl) {
      const bootstrap = (window as any).bootstrap;
      modalInstance = new bootstrap.Modal(modalEl);
    }
  }, 1000);
});


loadDataItems();

const setFile = (file) => {
  previewUrl.value = "";
  file_excel.value = file;
};

</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <div
        class="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4"
      >
        
        <h3 class="mb-0">List Data Item</h3>
        <div class="d-flex justify-content-between flex-wrap gap-3">
          <div class="w-full" v-if="hasAccess('goods-create')">
            <a
              class="btn btn-success text-white py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3"
              @click="modalShow = true"
            >
              <span class="py-sm-1 d-block">
                <i class="ri-add-line d-none d-sm-inline-block me-1"></i>
                <span>Import Item</span>
              </span>
            </a>
          </div>
          <div class="w-full" v-if="linkAdd != null && hasAccess('goods-create')">
            <a
              class="btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
              :href="linkAdd?.url"
            >
              <span class="py-sm-1 d-block">
                <i class="ri-add-line d-none d-sm-inline-block me-1"></i>
                <span>{{ linkAdd?.text }}</span>
              </span>
            </a>
          </div>
        </div>
        
      </div>
      <ItemFilter :link="linkAdd" @searchByQuery="loadDataItems" />
      <div class="table-content">
        <BaseLoading v-if="isLoading" />
        <EasyDataTable
          :headers="headers"
          :items="listItems"
          v-if="!isLoading"
          show-index
          :server-options="{
            page: page,
            rowsPerPage: limit,
          }"
          :server-items-length="totalItems"
          @update:server-options="handleServerOptionsUpdate"
          buttons-pagination
        >
          <template #item-image="props">
            <img :src="props.image_link" alt="image-link" class="image-item" />
          </template>
          <template #item-action="props">
            <div class="d-flex gap-2">
              <span
                class="material-symbols-outlined cursor-pointer"
                @click="handleVarian(props.id)"
              >
                dynamic_feed
              </span>
              <span
                v-if="hasAccess('goods-update')"
                class="material-symbols-outlined cursor-pointer"
                @click="handleEdit(props.id)"
              >
                edit
              </span>
              <span
                v-if="hasAccess('goods-delete')"
                class="material-symbols-outlined cursor-pointer"
                @click="handleDelete(props)"
              >
                delete
              </span>
            </div>
          </template>
        </EasyDataTable>
      </div>
    </div>
  </div>

<div
    class="modal fade"
    id="modalImport"
    tabindex="-1"
    aria-labelledby="modalImportLabel"
    aria-hidden="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog">
        <CustomSizeLoading text="Uploading Data..." :size="50" v-if="isLoading" />
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalImportLabel">Import Item from Excel</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="emptyStateModal"
          ></button>
        </div>

        <form @submit="submitFileImport" class="">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="form-group">
                    <label for="qty" class="form-label label text-secondary"
                      >File Import <span class="text-danger">*</span></label
                    >
                    <div class="position-relative">
                      <ExcelUploader @file-result="setFile" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-success text-white" @click="downloadFormatImport" >
              Download Format Import
            </button>
            <div class="d-flex justify-content-between flex-wrap gap-3">
              <button
                type="button"
                class="btn btn-secondary"
                @click="emptyStateModal"
              >
                Close
              </button>
              <button type="submit" class="btn btn-primary" >
                Submit
              </button>
            </div>
            
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<style>
.image-item {
  width: 200px;
  height: auto;
  object-fit: contain;
  padding: 10px;
}
</style>
